import React, { useState, useMemo } from "react";
import { Container } from "react-bootstrap";
import Image from "components/image";
import * as style from "./style.mod.scss";
import RichText from "components/rich-text";
import getImagePath from "helpers/get-image-path";
import OrangeCheckmark from "assets/svgs/Orangehack.svg";
import { ChevronDown } from "react-bootstrap-icons";
import hexToRGBA from "helpers/hex-to-rgba";

const TableProductInformation = ({ data }) => {
  const filteredItems = data?.section?.filter(item => item._type !== "productModule");
  const products = data?.section?.find(item => item?._type === "productModule")?.products;

  const transposeProdDetails = useMemo(() => {
    return filteredItems.map(item => {
      const maxProdDetailLength = Math.max(...item.column.map(col => col.prodDetail.length));
      const transposedColumn = Array.from({ length: maxProdDetailLength }, () => ({ prodDetail: [] }));

      item.column.forEach((col, colIndex) => {
        col.prodDetail.forEach((detail, detailIndex) => {
          transposedColumn[detailIndex].prodDetail[colIndex] = detail;
        });
      });

      return {
        ...item, column: transposedColumn
      };
    });
  }, [filteredItems]);

  const injectProductDetails = useMemo(() => {
    return transposeProdDetails.map(item => {
      item.column.forEach((column) => {
        for (let prodDetailIndex = 1; prodDetailIndex < column.prodDetail.length; prodDetailIndex++) {
          let productIndex = prodDetailIndex - 1;
          if (products[productIndex]) {
            let prodDetail = column.prodDetail[prodDetailIndex];
            prodDetail.mainTitle = products[productIndex].mainTitle;
            prodDetail.borderLayout = products[productIndex].borderLayout;
          }
        }
      });
      return item;
    });
  }, [transposeProdDetails, products]);

  const [openCategories, setOpenCategories] = useState({});
  const [openDetails, setOpenDetails] = useState({});

  const toggleCategory = (index) => {
    setOpenCategories((prev) => ({
      ...prev, [index]: !prev[index]
    }));
  };

  const toggleDetail = (detailKey) => {
    setOpenDetails((prev) => ({
      ...prev, [detailKey]: !prev[detailKey]
    }));
  };

  const ProdutDetails = ({ detailKey, detail, bgColor }) => (
    <div key={detailKey} className={style.productDetails}>
      <div className={style.prodCategoryTitle} onClick={() => toggleDetail(detailKey)} style={{ backgroundColor: openDetails[detailKey] ? hexToRGBA(detail?.borderLayout?.hex, 0.7) : detail?.borderLayout?.hex }}>
        <div className={style.title}>{detail?.mainTitle} <span className={`${style.accordionIcon} ${openDetails[detailKey] ? style.open : ""}`}><ChevronDown /></span></div>
      </div>
      {openDetails[detailKey] && (
        <div className={style.prodBox} style={{ backgroundColor: bgColor }}>
          {detail?.stars && detail?.imageAbove && (
            <img className={style.icon} src={getImagePath(detail?.stars)} alt={detail?.stars?.alt} />)}
          {detail?.textList &&
            <div className={style.prodContentBlock}><RichText blocks={detail?.textList} /></div>}
          {detail?.blueBox &&
            <div className={style.prodBlueBox}>
              <RichText blocks={detail?.blueBox} />
            </div>}
          {detail?.stars && !detail?.imageAbove && (
            <img className={style.icon} src={getImagePath(detail?.stars)} alt={detail?.stars?.alt} />)}
          {(detail?.checkmark) && <div className={style.checkmark}><OrangeCheckmark /></div>}
          {detail?.image && !detail?.roundedCorners && (<div className={style.prodImg}><Image image={detail?.image} alt={detail?.image?.alt} /></div>)}
          {detail?.image && detail?.roundedCorners && (<div className={style.roundedCornersImg}><Image image={detail?.image} alt={detail?.image?.alt} /></div>)}
        </div>
      )}
    </div>
  );


  return (
    <div className={`${style.tableProductInformation} ${style.tableProductInformationMobile}`} style={{ display: data.newLayout ? "none" : "" }}>
      <Container>
        {injectProductDetails?.map((item, i) => (
          <div key={i}>
            <p className={style.categoryTitle} style={{ backgroundColor: item?.bgColor?.hex }} onClick={() => toggleCategory(i)}>{item?.title}
              <span className={`${style.accordionIcon} ${openCategories[i] ? style.open : ""}`}><ChevronDown /></span></p>
            {openCategories[i] && item?.column?.slice(1)?.map((box, boxIndex) => (
              <React.Fragment key={boxIndex}>
                <div className={style.prodContentBlock} style={{ paddingTop: "1rem" }}>
                  <RichText blocks={box?.prodDetail[0]?.textList} />
                </div>
                {box?.prodDetail?.slice(1)?.map((detail, detailIndex) => {
                  const detailKey = `${boxIndex}-${detailIndex}`;
                  const bgColor = hexToRGBA(detail?.borderLayout?.hex, 0.1);
                  return (
                    <ProdutDetails key={detailKey} detailKey={detailKey} detail={detail} bgColor={bgColor} />
                  );
                })}
              </React.Fragment>
            ))}
          </div>
        ))}
      </Container>
    </div >
  );
};

export default TableProductInformation;